  <fieldset #accelaControlDiv [id]="this.getDivElementId()" class="accelaControl component-content radioOptions" [formGroup]="this.controlRef.parent" tooltipEvent="hover|focus" tooltipPosition="bottom" [accelaTooltip]="this.controlData.tooltip" [escape]="false">
    <legend>
      <label [for]="this.getDivElementId()" [attr.data-required]="this.controlData.required">{{this.controlData.label}}</label>
    </legend>
      <div *ngFor="let opt of this.controlData.options; let idx=index">
          <p-radioButton [name]="this.controlData.name" [id]="this.controlData.name+'_'+idx" [label]="this.getOptionLabel(this.opt)" [attr.aria-required]="this.controlData.required" 
            [ariaLabel]="this.opt.label" [required]="this.controlData.required" [disabled]="readonlyMode"
            [appendTo]="accelaControlDiv" [formControlName]="this.controlData.name" [value]="this.opt.value" (onBlur)="emitBlurEvent($event)"></p-radioButton>
          <div class="spacer"></div>
          <!-- <span>{{this.opt | json}}</span> -->
          <!-- <label [for]="this.getLabelElementId()" [id]="this.getLabelElementId()" [attr.data-required]="this.controlData.required">{{this.opt.label}}</label> -->
      </div>
  </fieldset>
  <div *ngIf="!this.adminMode" class="validationFeedback">
      <!-- <span>{{this.controlRef.value | json}}</span><br/> -->
      <!-- <span>{{this.controlRef.errors | json}}</span> -->
      <small *ngIf="this.controlRef?.errors?.required && (this.controlRef?.touched || this.controlRef?.dirty)"
          class="ng-invalid p-invalid">
          {{this.getRequiredFieldValidationMsg()}}
      </small>
  </div>    
